import { render, staticRenderFns } from "./BtnCreateDataExport.vue?vue&type=template&id=0478a06e&scoped=true&"
import script from "./BtnCreateDataExport.vue?vue&type=script&lang=js&"
export * from "./BtnCreateDataExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478a06e",
  null
  
)

export default component.exports